<template>
  <div class="news">
    <div class="container">
      <div :style="{ fontSize: fontSize.h5 + 'em' }" class="title">NEWS</div>
      <marquee
        loop="-1"
        behavior="scroll"
        SCROLLAMOUNT="5"
        onmouseover="this.stop();"
        onmouseout="this.start();"
      >
        <template v-for="message in MarqueeList" :key="message.pageId">
          <a
            :href="message.pageLink"
            target="_blank"
            :title="'【另開新視窗】' + message.pageTitle"
          >
            <span>{{ message.pageTitle }}</span>
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          </a>
        </template>
      </marquee>
    </div>
  </div>
</template>

<script>
import { inject, reactive } from "vue";
import { apiNewsMarquee } from "@/api/api.js";

export default {
  name: "HotCountry",
  props: [],
  setup() {
    let fontSize = inject("fontSize");
    // 跑馬燈內容
    const MarqueeList = reactive([]);
    apiNewsMarquee()
      .then((res) => {
        res.data.forEach((message) => {
          MarqueeList.push(message);
        });
      })
      .catch((err) => {
        console.log(err);
      });

    return {
      fontSize,
      MarqueeList,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.news {
  .container {
    @include main_bgcolor();
    @include flex_between();
    padding: 10px;
    .title {
      color: $main_sec_color;
      padding-right: 15px;
    }
    span {
      color: #fff;
    }
  }
}

.marquee {
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}
.marquee p {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 15s linear infinite;
}
@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}
</style>
